import React from 'react';
import CustomHead from '../components/common/head/Head';
import { apiUrl } from '../config/apiConfig';
import axios from 'axios';
import { metaSiteTitle } from '../config/defaultMetaConfig';
import SectionTitle from '../components/common/section/SectionTitle';


const ContactPage = ({ siteSetting }) => {
  // console.log("siteSetting", siteSetting);
  return (
    <>
      <CustomHead
        title={
          "About Us | " +
          (siteSetting && siteSetting.title ? siteSetting.title : metaSiteTitle)
        }
      />
      <div className="page-area about-page-area mh-80v">
        <div className="goal-area position-relative py-5">
          <div className="container">
            <div className="row position-relative justify-content-center zi-3">
              <div className="col-lg-9">
                <SectionTitle title="About Us" />
              </div>
            </div>
            <div className="goal-content-area position-relative mt-3 mt-lg-0">
              <div className="row position-relative zi-3">
                <div className="col-lg-12">
                  <div
                    className={`goal-box-area d-flex flex-column h-100 radius-24 bg-white p-5`}
                  >
                    <div className="goal-box-inner flex-grow-1">
                      {siteSetting && siteSetting.description && (
                        <div className="fs-28 lh-48 mb-0 text-justify text-purple-dark">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: siteSetting.description,
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps() {
  try {
    const siteSetting = await axios.get(apiUrl + '/api/siteSetting')
      .then((response) => {
        return response.data.data
      })
      .catch((error) => {
        return null
      });


    return {
      props: {
        siteSetting: siteSetting,
        loaded: true,
      }
    }
  } catch (error) {
    return {
      props: {
        siteSetting: null,
        loaded: true,
      }
    }
  }
}

export default ContactPage;